import { Timestamp } from '@angular/fire/firestore';

export interface AssetConfig {
  ductOverride: boolean;
  pumpSpeed: number;
  fanSpeed: number;
  isPaused: boolean;
  pausedTill: Timestamp;
  logInterval: number;
}
